/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Request_Access_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to send access request." |
*
* @param {Artifact_Request_Access_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_request_access_error = /** @type {((inputs?: Artifact_Request_Access_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Request_Access_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zugriffsanfrage konnte nicht gesendet werden.")
	return /** @type {LocalizedString} */ ("Failed to send access request.")
});